/* eslint-disable react/destructuring-assignment */
import { Avatar, Tooltip, Checkbox, Tag, Image } from "antd";
import React, { useState } from "react";
import { convertUtcToLocal } from "../../../../library/utils";
import { convertToInitials } from "../../../layoutComponent/layoutHelpers";
import { dateFromNow } from "../Emails";
import { cleanHtmlForPreview } from "../../../../utils/htmlHelpers";
import { EMAIL_TYPE_ENUMS, renderEmailStatus } from "../../../../constant/EmailConstant";
import { EmailTypeIcon } from "../../../email-view/emailHeader";
import BouncedEmailResend from "./BouncedEmailResend";

/**
 *
 * @param {{item:import("./emailMockData").EmailsData, selectedEmail:import("./emailMockData").EmailsData,setselectedEmail:(data:import("./emailMockData").EmailsData)=>{}, selectedIds: string[], handleCheckboxChange: (id: string, checked: boolean) => void}} props
 * @returns
 */
export const EmailCard = props => {
  const { item, selectedEmail, selectedIds, handleCheckboxChange } = props;
  const [isAvatarHovered, setIsAvatarHovered] = useState(false);

  return (
    <div
      className={`${selectedEmail?.id === item?.id ? "bg-[#E6F4FF]" : ""} cursor-pointer`}
      onClick={() => props.setselectedEmail(item)}
    >
      <div className="p-4 w-full">
        <div className="flex-row-centered w-full items-start gap-3">
          <div
            className="relative min-h-8 min-w-8 flex items-center justify-center overflow-hidden rounded-full bg-white"
            onMouseEnter={() => setIsAvatarHovered(true)}
            onMouseLeave={() =>
              setTimeout(() => {
                setIsAvatarHovered(false);
              }, 100)
            }
            onClick={e => e.stopPropagation()}
          >
            {/* Avatar - shown only when not selected AND not hovered */}
            {!selectedIds.includes(item.sesMessageId) && (
              <div
                className={`absolute inset-0 flex items-center justify-center transition-all duration-200 ease-in-out ${
                  isAvatarHovered ? "opacity-0 scale-95" : "opacity-100 scale-100"
                }`}
              >
                <Avatar className="!rounded-full h-8 w-8 text-white font-medium">
                  {convertToInitials(item?.lead?.fullName)}
                </Avatar>
              </div>
            )}

            {/* Checkbox - shown on hover OR if already selected */}
            {(isAvatarHovered || selectedIds.includes(item.sesMessageId)) && (
              <div className="absolute inset-0 flex items-center justify-center transition-all duration-200 ease-in-out opacity-100 scale-100">
                <Checkbox
                  checked={selectedIds.includes(item.sesMessageId)}
                  onChange={e => handleCheckboxChange?.(item.sesMessageId, e.target.checked)}
                  className="h-7 w-7 flex items-center justify-center"
                />
              </div>
            )}
          </div>

          <div className="flex-col-centered w-[calc(100%-40px)] gap-1 relative">
            <div className="flex-row-centered items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-[14px] font-semibold">{item?.lead?.fullName}</span>
                {renderEmailStatus(item?.status)}
                {item?.type && item?.type !== EMAIL_TYPE_ENUMS.MANUAL && (
                  <EmailTypeIcon className="-ml-1" type={item.type} />
                )}
              </div>
              <Tooltip title={convertUtcToLocal(item.createTs, "LLLL")}>
                <span className="text-[#000000A6] text-xs font-normal text-end">
                  {dateFromNow(item.latestActivityTs)}
                </span>
              </Tooltip>
            </div>
            {/* Absolutely positioned below the timestamp so it doesn't grow
                the header row and push the subject down. */}
            <BouncedEmailResend
              buttonOnly
              className="absolute right-0 top-5"
              direction={item?.message?.direction}
              status={item?.status}
              to={item?.to}
              subject={item?.subject}
              content={item?.bodyHtml || item?.message?.content}
              leadId={item?.lead?.id || item?.message?.leadId}
              leadOpportunityId={item?.message?.leadOpportunityId}
              onResent={() => props.refetchEmails?.()}
            />
            <Tooltip title={item.subject}>
              <div className="font-normal mt-2 text-black text-[14px] truncate">{item.subject}</div>
            </Tooltip>
            <div className="text-[14px] text-[rgba(0,_0,_0,_0.45)] truncate line-clamp-1 flex-row-centered items-center">
              {cleanHtmlForPreview(item.bodyHtml, 42)}
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-0.5 bg-grey-200" />
    </div>
  );
};
